// Shared Tailwind class strings for consistent styling across admin forms and public pages.

export const inputClass =
    "w-full bg-slate-50 border border-slate-200 rounded-2xl py-2.5 px-3 font-bold text-sm focus:outline-none focus:ring-2 focus:ring-brand"

export const labelClass = "block text-xs font-black uppercase tracking-widest text-slate-500 mb-1"

export const sectionClass = "bg-white rounded-[28px] border border-slate-100 shadow-xl p-6 space-y-4"

export const primaryBtnClass =
    "flex items-center gap-2 px-5 py-2.5 rounded-[28px] bg-brand text-white font-black text-sm hover:bg-brand-dark transition-colors active:scale-95 disabled:opacity-50 shadow-md"

export const submitBtnClass =
    "w-full bg-brand text-white font-black rounded-[28px] shadow-xl hover:bg-brand-dark active:scale-95 transition-all duration-200 py-3 text-base mt-2"

export const sectionHeaderClass = "text-lg font-black text-slate-900"
